import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/product', // 产品
      name: 'product',
      component: () => import('./views/Product/Product.vue'),
    },
    {
      path: '/product_search', // 产品搜索结果页面
      name: 'product_search',
      component: () => import('./views/Product/Product_search.vue'),
    },
    {
      path: '/classify', // 产品二级
      name: 'classify',
      component: () => import('./views/Product/Classify.vue')
    },
    {
      path: '/details', // 产品三级
      name: 'details',
      component: () => import('./views/Product/Product_details.vue')
    },



    {
      path: '/problem', // 常见问题
      name: 'problem',
      component: () => import('./views/Problem/Problem.vue')
    },
    {
      path: '/problemdetails', // 常见问题
      name: 'problemdetails',
      component: () => import('./views/Problem/Problem_details.vue')
    },



    {
      path: '/downlaod', // 资料下载
      name: 'downlaod',
      component: () => import('./views/Download.vue')
    },

    {
      path: '/contact', // 联系我们
      name: 'contact',
      component: () => import('./views/Contact.vue')
    },
    
    {
      path: '/about', // 关于我们
      name: 'about',
      component: () => import('./views/About.vue')
    },


    {
      path: '/news', // 新闻中心
      name: 'news',
      component: () => import('./views/News/News.vue')
    },
    {
      path: '/newsdetails', // 新闻中心
      name: 'newsdetails',
      component: () => import('./views/News/News_details.vue')
    },
  ]
})
